<template>
  <div class="about-area">
    <div class="container">
      <!-- Trending Tittle -->
      <div class="row">
        <div class="col-lg-12">
          <div class="trending-tittle"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <!-- Trending Tittle -->
          <div class="about-right mb-90">
            <div class="section-tittle mb-30 pt-30">
              <h3 style="text-align: center;">ĐIỀU KIỆN THỰC HIỆN HÌNH THỨC ĐẤU GIÁ TRỰC TUYẾN</h3>
            </div>
            <div class="about-prea" style="text-align: justify;">
              <p class="about-pera1">
                Nhằm phát triển theo định hướng chuyên nghiệp hóa hoạt động bán đấu giá, đảm bảo tuân thủ pháp luật, với
                các tiêu chí hoạt động chuyên nghiệp, thủ tục thực hiện đấu giá công khai, minh bạch, hiệu quả, từ ngay
                sau khi Luật Đấu giá tài sản năm 2016 có hiệu lực (ngày 01/7/2017), Công ty Đấu giá Hợp danh Số 5 – Quốc
                gia đã có kế hoạch chiến lược phát triển hình thức đấu giá trực tuyến này trong hơn 02 năm, Công ty đã
                rất tâm huyết và mạnh dạn nghiên cứu các quy định của pháp luật đấu giá tài sản, pháp luật về thương mại
                điện tử và các văn bản pháp luật khác có liên quan để xây dựng “Đề án thực hiện hình thức đấu giá trực
                tuyến”.
              </p>
              <p class="about-pera1">
                Ngày 12/5/2020, Sở Tư pháp thành phố Hà Nội đã chính thức ban hành Quyết định số 112/QĐ-STP về việc phê
                duyệt tổ chức đấu giá tài sản đủ điều kiện thực hiện hình thức đấu giá trực tuyến. Như vậy, Công ty Đấu
                giá Hợp danh Số 5 – Quốc gia trở thành tổ chức đấu giá tài sản đầu tiên trên cả nước được cơ quan có
                thẩm quyền phê duyệt đủ điều kiện thực hiện hình thức đấu giá trực tuyến theo quy định tại Luật đấu giá
                tài sản 2016.
              </p>
              <p class="about-pera1">
                Để được Sở tư pháp phê duyệt, Công ty đã gửi Đề án thực hiện hình thức đấu giá trực tuyến đến Sở Tư pháp
                thành phố Hà Nội. Giám đốc Sở Tư pháp quyết định thành lập Hội đồng thẩm định điều kiện thực hiện hình
                thức đấu giá trực tuyến bao gồm các chuyên gia có kinh nghiệm trong lĩnh vực đấu giá tài sản cũng như
                công nghệ thông tin và ban hành quy chế hoạt động của Hội đồng. Hội đồng đã thẩm định “Đề án thực hiện
                hình thức đấu giá trực tuyến” do Công ty Đấu giá hợp danh Số 5 – Quốc gia xây dựng đáp ứng đủ các điều
                kiện quy định tại Điều 13 Nghị định 62/2017/NĐ-CP như sau:
              </p>
              <p class="about-pera1">
                “1. Tổ chức đấu giá tài sản thiết lập Trang thông tin điện tử để tổ chức phiên đấu giá dưới hình thức
                đấu giá trực tuyến theo quy định của Luật đấu giá tài sản phải đáp ứng các điều kiện sau đây:
              </p>
              <p class="about-pera1">a) Có hệ thống hạ tầng kỹ thuật để thực hiện đấu giá trực tuyến;</p>
              <p class="about-pera1">
                b) Có đội ngũ nhân viên điều hành hệ thống kỹ thuật Trang thông tin điện tử đấu giá trực tuyến;
              </p>
              <p class="about-pera1">
                c) Có phương án, giải pháp kỹ thuật bảo đảm vận hành an toàn hệ thống kỹ thuật Trang thông tin điện tử
                đấu giá trực tuyến.
              </p>
              <p class="about-pera1">
                2. Hệ thống hạ tầng kỹ thuật để thực hiện phiên đấu giá trực tuyến phải có các chức năng tối thiểu sau
                đây:
              </p>
              <p class="about-pera1">
                a) Đảm bảo tính an toàn, bảo mật về tài khoản truy cập và toàn vẹn dữ liệu, việc tham gia trả giá, giá
                đã trả và các thông tin về người tham gia đấu giá;
              </p>
              <p class="about-pera1">
                b) Ghi nhận và lưu trữ tất cả mức giá được trả trong phiên đấu giá, việc rút lại giá đã trả và những
                thông tin cần thiết khác trong quá trình diễn ra phiên đấu giá trực tuyến;
              </p>
              <p class="about-pera1">
                c) Hiển thị công khai, trung thực giá trả của người tham gia đấu giá; trích xuất được lịch sử việc trả
                giá trên hệ thống đấu giá trực tuyến;
              </p>
              <p class="about-pera1">
                đ) Hiển thị mức giá cao nhất được hệ thống đấu giá trực tuyến ghi nhận 30 giây một lần để những người
                tham gia đấu giá có thể xem được.”
              </p>
              <p class="about-pera1">
                Công ty Đấu giá Hợp danh Số 5 – Quốc gia cam kết đáp ứng đầy đủ các điều kiện cần và đủ về đội ngũ nhân
                sự có trình độ nghiệp vụ, chuyên nghiệp và hệ thống hạ tầng kỹ thuật để thực hiện đấu giá trực tuyến,
                cùng với phương án, giải pháp kỹ thuật bảo đảm vận hành an toàn hệ thống kỹ thuật Trang thông tin điện
                tử đấu giá trực tuyến, phù hợp với quy định tại Điều 13 Nghị định 62/2017/NĐ-CP. Với bề dày kinh nghiệm
                và uy tín đã được tích lũy trong thời gian qua, chúng tôi tin tưởng sẽ luôn đồng hành cùng khách hàng để
                vượt qua khó khăn, nắm bắt cơ hội để cùng nhau xây dựng một thị trường đấu giá tài sản công khai, minh
                bạch và phát triển bền vững.
              </p>
              <p class="about-pera1">Trân trọng./.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js';
export default {
  name: 'About',
  mixins: [mixin],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/News/5.vue